import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { Text, TextType } from 'ui-components/components/text';
import { FlexColumn } from 'ui-components/components/flex';

import Global from '../../../../../store/global-selectors';
import { US, AU, GB } from '../../../../../constants/country-codes';
import USCarrierLogos from '../../set-up-banner/svgs/US_Logos.svg';
import AUCarrierLogos from '../../set-up-banner/svgs/AU_Logos.svg';
import GBCarrierLogos from '../../set-up-banner/svgs/GB_Logos.svg';
import style from './promotional-section.module.less';
import messages from './messages';

const defaultPromotionalConfig = {
  subtext: messages.promotionalSubtext,
  carrierLogos: USCarrierLogos,
  altText: messages.carrierLogosAlt,
};

const promotionalConfigByCountry = {
  [US]: defaultPromotionalConfig,
  [AU]: {
    subtext: messages.genericPromotionalSubtext,
    carrierLogos: AUCarrierLogos,
  },
  [GB]: {
    subtext: messages.genericPromotionalSubtext,
    carrierLogos: GBCarrierLogos,
  },
};

export const PromotionalSection = () => {
  const intl = useIntl();
  const homeCountry = useSelector(Global.selectSellerHomeCountry);

  const { subtext, carrierLogos } = promotionalConfigByCountry[homeCountry] || defaultPromotionalConfig;

  return (
    <div className={style['promotional-section']}>
      <FlexColumn className={style['promotional-content']}>
        <Text className={style['promotional-header']} textType={TextType.H1} value={<FormattedMessage {...messages.promotionalHeader} />} />
        <Text className={style['promotional-subtext']} textType={TextType.H4} value={<FormattedMessage {...subtext} />} />
        <img alt={intl.formatMessage(messages.carrierLogosAlt)} className={style['carrier-logo']} src={carrierLogos} />
      </FlexColumn>
    </div>
  );
};
